import { FC } from 'react';
import { Breadcrumb, Col, Row, Space, Typography } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';

import { IPageWrapper } from './types';
import {
  Wrapper,
  StyledButton,
  StyledTitle,
  PageContainer,
  PageHeader
} from './styled';
import Loading from '../Loading';

const { Text } = Typography;

const PageWrapper: FC<IPageWrapper> = ({
  title,
  children,
  breadcrumbs,
  back,
  badge = null,
  color = 'layout-body-background',
  extra,
  loading,
  description,
  style,
  hidePaddings
}) => {
  // navigation
  const navigate = useNavigate();

  return (
    <Wrapper>
      {!!title && (
        <PageHeader>
          {!!breadcrumbs?.length && (
            <Breadcrumb
              style={{
                flex: '1 1 100%',
                textTransform: 'capitalize',
                marginBottom: 8
              }}
            >
              {breadcrumbs.map((b, i, arr) => (
                <Breadcrumb.Item key={b}>
                  {i === arr.length - 1 ? (
                    b
                  ) : (
                    <Link to={'/' + b?.toLowerCase()}>{b}</Link>
                  )}
                </Breadcrumb.Item>
              ))}
            </Breadcrumb>
          )}
          <Row justify="space-between" align="middle">
            <Col>
              <Space direction="vertical" size={0}>
                <StyledTitle
                  className="page-wrapper-title"
                  level={2}
                  style={{ marginBottom: 0 }}
                >
                  {back && (
                    <StyledButton
                      type="link"
                      icon={<ArrowLeftOutlined />}
                      onClick={() => navigate(-1)}
                    />
                  )}
                  {title}
                  {badge}
                </StyledTitle>
                <Text style={{ color: '#6B7083' }}>{description}</Text>
              </Space>
            </Col>
            <Col>{!!extra && <Space>{extra}</Space>}</Col>
          </Row>
        </PageHeader>
      )}
      <PageContainer style={style} $hidePaddings={hidePaddings} $color={color}>
        {loading ? <Loading /> : children}
      </PageContainer>
    </Wrapper>
  );
};

export default PageWrapper;
